import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { ToastContainer } from 'react-toastify'
import { PersistGate } from 'redux-persist/integration/react'
import Modal from 'react-modal'

import 'react-dates/lib/css/_datepicker.css'
import 'react-toastify/dist/ReactToastify.css'

import store, { history, persistor } from '../src/store'

import * as serviceWorker from './serviceWorker'
import IdleTimer from './IdleTimer'

const Root = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <IdleTimer />
        <ToastContainer />
      </ConnectedRouter>
    </PersistGate>
  </Provider>
)

Modal.setAppElement('#app')
ReactDOM.render(<Root />, document.getElementById('app'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
